import QrLandingPageActionTypes from '../actions/qr-landing-page-action-types';

const initialState = {
  loading: false,
  result: null,
  errorMessage: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case QrLandingPageActionTypes.SCAN_QR_TOKEN_START:
      return {
        ...state,
        loading: true,
        result: null,
        errorMessage: null
      };
    case QrLandingPageActionTypes.SCAN_QR_TOKEN_END:
      return {
        ...state,
        loading: false,
        result: action.payload?.result ?? null,
        errorMessage: action.payload?.errorMessage ?? null
      };
    default:
      return state;
  }
};
